/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Home, Folder, Folders, ChevronRight } from 'lucide-react';
import { documentTableItem, FolderItem } from '../../../lib/models/interfaces';
import {
  primaryButtonGreen,
  primaryGreenDarker
} from '../../tokenStyle/tokeReset';
import { DocumentContext } from '../../../context/documentContext';
import logger, { createLogger } from '../../../helpers/Logger';
interface HomeProps {
  showBackButton: boolean;
  currentFolder: string | null;
  projectId: string | null;
}
export const BackAndHomeButtons: React.FC<HomeProps> = ({
  showBackButton,
  currentFolder,
  projectId
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { currentDoc } = useContext(DocumentContext);

  const handleBack = () => {
    console.log('location', location);
    const paths = location.pathname.split('/');

    console.log('paths', paths);
    if (paths.length > 5) {
      navigate(`/${paths[1]}/${paths[2]}`);
    }
    if (paths.includes('simple-viewer')) {
      navigate(
        `/app/projects/${currentDoc.project}/folder/${currentDoc.folder}`
      );
    }
    // navigate(-1); // Goes back to the previous page
  };

  const handleHome = () => {
    navigate('/'); // Navigates to the home page
  };
  const handleFolder = () => {
    navigate(`/app/projects/${projectId}/folder/${currentFolder}`);
  };
  const handleProject = () => {
    navigate(`/app/projects/${projectId}`);
  };
  const buttonStyle = `p-2 border border-[${primaryGreenDarker}] rounded-full text-[${primaryGreenDarker}] hover:bg-[${primaryGreenDarker}]  hover:border-[white] hover:text-white transition duration-200`;
  return (
    <div className="flex items-left justify-start gap-4 p-2">
      {showBackButton && (
        <p>Back</p>
        // <button onClick={handleBack} className={buttonStyle} aria-label="Back">
        // {/* <ArrowLeft className="w-3 h-3" /> */}
        // </button>
      )}
      <button onClick={handleHome} className={buttonStyle} aria-label="Home">
        <Home className="w-3 h-3" />
      </button>
      {projectId ? (
        <button
          onClick={handleProject}
          className={buttonStyle}
          aria-label="Folder"
        >
          <Folders className="w-3 h-3" />
        </button>
      ) : null}
      {currentFolder ? (
        <button
          onClick={handleFolder}
          className={buttonStyle}
          aria-label="Folder"
        >
          <Folder className="w-3 h-3" />
        </button>
      ) : null}
    </div>
  );
};
export const DocumentViewButtons: React.FC<HomeProps> = ({
  showBackButton,
  currentFolder,
  projectId
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Goes back to the previous page
  };

  const handleHome = () => {
    navigate('/'); // Navigates to the home page
  };
  const handleFolder = () => {
    navigate(`/app/projects/${projectId}/folder/${currentFolder}`);
  };
  const handleProject = () => {
    navigate(`/app/projects/${projectId}`);
  };

  return (
    <div className="flex items-left justify-start gap-4 p-0 ">
      <button
        onClick={handleHome}
        className="p-2 border border-blue-500 rounded-full hover:bg-blue-100 text-blue-500 hover:text-blue-600 transition duration-200"
        aria-label="Home"
      >
        <Home className="w-3 h-3" />
      </button>
      {projectId ? (
        <button
          onClick={handleProject}
          className="p-2 border border-blue-500 rounded-full hover:bg-blue-100 text-blue-500 hover:text-blue-600 transition duration-200"
          aria-label="Folder"
        >
          <Folders className="w-3 h-3" />
        </button>
      ) : null}
      {currentFolder ? (
        <button
          onClick={handleFolder}
          className="p-2 border border-blue-500 rounded-full hover:bg-blue-100 text-blue-500 hover:text-blue-600 transition duration-200"
          aria-label="Folder"
        >
          <Folder className="w-3 h-3" />
        </button>
      ) : null}
      {showBackButton && (
        <button
          onClick={handleBack}
          className="p-2 border border-blue-500 rounded-full hover:bg-blue-100 text-blue-500 hover:text-blue-600 transition duration-200"
          aria-label="Back"
        >
          <ArrowLeft className="w-3 h-3" />
        </button>
      )}
    </div>
  );
};
interface BreadcrumbProps {
  documents?: documentTableItem[];
  carouselIndex?: number;
}
export const BreadcrumbsPills: React.FC<BreadcrumbProps> = ({
  documents,
  carouselIndex = 0
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const logger = createLogger({ prefix: '[BreadcrumbPills]' });
  const [items, setItems] = useState<{ label: string; to: string }[]>([
    { label: 'Home', to: '/landing' }
  ]);

  function truncate(str: string, n: number) {
    return str.length > n ? str.slice(0, n) + '...' : str;
  }
  useEffect(() => {
    const path = location.pathname;
    const pathArray = path.split('/');
    const nextItems: { label: string; to: string }[] = [
      { label: 'Home', to: '/landing' }
    ];

    logger.info('path array', pathArray);
    logger.info('includes project', pathArray.includes('projects'));
    if (pathArray.includes('projects')) {
      nextItems.push({ label: 'Projects', to: '/app/projects' });
    }
    if (pathArray.includes('folder')) {
      nextItems.push({ label: 'Folder', to: '/app/' });
    }
    if (
      documents &&
      documents.length > 0 &&
      pathArray.includes('simple-viewer')
    ) {
      logger.info('projectId', documents[carouselIndex].project);
      logger.info('currentFolder', documents[carouselIndex].folder);
      const localIndex = carouselIndex ?? 0;
      setItems([
        { label: 'Home', to: '/landing' },
        { label: 'Projects', to: '/app/projects' },
        {
          label: 'Folder',
          to: `/app/projects/${documents[localIndex].project}/folder/${documents[localIndex].folder}`
        },
        {
          label: `${documents[localIndex].documentFileName ? truncate(documents[localIndex].documentFileName, 50) : 'Document'}`,
          to: ''
        }
      ]);
      return;
    }
    setItems(nextItems);
  }, [location, documents, carouselIndex]);

  return (
    <div className="inline-flex bg-[#56dac5] border border-gray-200 px-4 py-2 rounded-md">
      <nav className="text-sm">
        <ol className="flex items-center space-x-1">
          {items.map((item, idx) => {
            const isLast = idx === items.length - 1;

            return (
              <li key={item.to} className="flex items-center">
                <button
                  type="button"
                  disabled={isLast}
                  onClick={() => !isLast && navigate(item.to)}
                  className={
                    isLast
                      ? 'font-medium hover:font-bold text-white cursor-default'
                      : 'text-white/90 hover:text-white hover:font-bold transition'
                  }
                >
                  {item.label}
                </button>

                {!isLast && (
                  <ChevronRight className="mx-1 h-4 w-4 text-white" />
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};
